import Image from 'components/Image';
import React, { useContext, useEffect, useState } from 'react';
import Step1 from '../../../images/earn-step-1.svg';
import Step2 from '../../../images/earn-step-2.svg';
import Step3 from '../../../images/earn-step-3.svg';
import Step4 from '../../../images/earn-step-4.svg';
import Link from '@mui/material/Link';
import UserContext from '../../General/UserContext';
import HiveBtn from './HiveBtn';

export default function EarnText({ isDashboard, isOnlyHive }) {
  const [hive, setHive] = useState(isOnlyHive);

  const { theme } = useContext(UserContext);
  const isDarkTheme = theme === 'dark';

  useEffect(() => {
    if (isOnlyHive || (window && window.hive_keychain)) {
      setHive(true);
    }
  });

  const textClass = `lead${isDarkTheme ? ' text-white' : ''}`;

  return (
    <>
      <h1 className="featuretteh1-heading pt-4">
        Earn cryptocurrency by travel blogging
      </h1>
      <div className="row featurette justify-content-center">
        <div className="col-md-7">
          <h2 className="featurette-heading">
            Web 3.0 is here.{' '}
            <span className="text-muted">It&apos;ll blow your mind.</span>
          </h2>
          <p className={textClass}>
            Leading Web 2.0 social media platforms rake in billions of
            advertising dollars. Not only are you not getting paid for your
            content, these platforms also sell your data and demand payment from
            you for your content to be seen by your followers.
          </p>
          <p className={textClass}>
            When we started building TravelFeed, we knew that we wanted to build
            something that benefits not only us, but you and all travel content
            creators. This is why we are leveraging cutting-edge blockchain
            technology to bring you the best features Web 3.0 has to offer.
          </p>
        </div>
        <div className="col-md-5 my-auto">
          <div className="d-flex justify-content-center">
            <div
              className="rounded-circle"
              style={{ width: 300, height: 300, background: '#F8941A' }}
            >
              <Image
                priority
                alt="Earn crypto"
                src={Step1}
                height={300}
                width={300}
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="featurette-divider" />
      <div className="row featurette">
        <div className="col-md-7 order-md-2">
          <h2 className="featurette-heading">
            Do what you love.{' '}
            <span className="text-muted">Create awesome travel content.</span>
          </h2>
          <p className={textClass}>
            We support cross-posting to Hive, the leading blockchain in the
            social blockchain space. Hive pays out rewards in form of its native
            cryptocurrency to content creators.
          </p>
          <p className={textClass}>
            All you have to do is link your Hive account in your TravelFeed
            dashboard. Keep creating awesome travel content and let us take care
            of cross-posting all your posts, comments and votes to Hive.
          </p>
        </div>
        <div className="col-md-5 my-auto order-md-1">
          <div className="d-flex justify-content-center">
            <div
              className="rounded-circle"
              style={{ width: 300, height: 300, background: '#f7b500' }}
            >
              <Image alt="Earn crypto" src={Step2} height={300} width={300} />
            </div>
          </div>
        </div>
      </div>
      <hr className="featurette-divider" />
      <div className="row featurette">
        <div className="col-md-7">
          <h2 className="featurette-heading">
            The community votes on your posts.{' '}
            <span className="text-muted">
              That&apos;s how your reward is determined.
            </span>
          </h2>
          <p className={textClass}>
            We review all posts that match our minimum requirements, upvote them
            and highlight our top picks, but ultimately the community determines
            the value of your post.
          </p>
          {isDashboard && (
            <p className={textClass}>
              By enabling the Hive integration, your post will also receive more
              exposure and interaction: Our HiveSync runs every hour to check
              for votes and replies to your post made by TravelFeed users on
              Hive and syncs them to TravelFeed.
            </p>
          )}
        </div>
        <div className="col-md-5 my-auto">
          <div className="d-flex justify-content-center">
            <div
              className="rounded-circle"
              style={{ width: 300, height: 300, background: '#278ea5' }}
            >
              <Image alt="Earn crypto" src={Step3} height={300} width={300} />
            </div>
          </div>
        </div>
      </div>
      <hr className="featurette-divider" />
      <div className="row featurette">
        <div className="col-md-7 order-md-2">
          <h2 className="featurette-heading">
            Travel, Write, Earn, <span className="text-muted">Repeat!</span>
          </h2>
          <p className={textClass}>
            After seven days, you will receive your reward in the
            blockchain&apos;s native cryptocurrencies HIVE and HBD which you can
            pay out, convert to Bitcoin or your local currency such as USD to
            pay for your travels or hold to gain more influence on Hive.
          </p>
          <p className={`${textClass} highlightLinks`}>
            Also, we are regularly giving away cryptocurrency in contests and
            sweepstakes - keep an eye on our{' '}
            <Link href="/contests">contest page</Link>!
          </p>
        </div>
        <div className="col-md-5 my-auto order-md-1">
          <div className="d-flex justify-content-center">
            <div
              className="rounded-circle"
              style={{ width: 300, height: 300, background: '#29c7ac' }}
            >
              <Image alt="Earn crypto" src={Step4} height={300} width={300} />
            </div>
          </div>
        </div>
      </div>
      <hr className="featurette-divider" />
      <div className="row featurette">
        <div className="col-md-7">
          <h2 className="featurette-heading">
            Oh yeah, it&apos;s that good.{' '}
            <span className="text-muted">See for yourself.</span>
          </h2>
          {hive ? (
            <>
              <p className={`${textClass} highlightLinks`}>
                {isDashboard
                  ? 'Y'
                  : `Are you new to Travelfeed but already have a Hive account? You can simply sign in to Travelfeed with Hive and the Hive integration will be enabled automatically! If you already have a Travelfeed account that's not linked to your Hive account, y`}
                ou can link your Hive account to your TravelFeed account{' '}
                {isDashboard ? (
                  'below'
                ) : (
                  <Link href="/dashboard/settings">
                    in your Dashboard settings
                  </Link>
                )}
                .
              </p>
              <p className={`${textClass} highlightLinks`}>
                {isDashboard
                  ? 'If you already have a Hive account, connect it below to enable the Hive integration.'
                  : ''}{' '}
                If you don&apos;t have a Hive account yet, you can create one
                for free by clicking the button. Follow the steps on Hive
                Onboard and be sure to save your private keys! After you
                complete creating your Hive account, link your Hive account to
                your TravelFeed account and enable cross-posting.
              </p>
            </>
          ) : (
            <>
              <p className={`${textClass} highlightLinks`}>
                Are you new to Travelfeed but already have a Hive account? You
                can simply sign in to Travelfeed with your Hive account and the
                integration will be enabled automatically! If you already have a
                TravelFeed account, you can link your Hive account to your
                TravelFeed account{' '}
                <Link href="/dashboard/settings">
                  in your Dashboard settings
                </Link>
                .
              </p>
              <p className={`${textClass} highlightLinks`}>
                Visit our{' '}
                <Link href="/help/category/integrations">
                  integrations page
                </Link>{' '}
                to learn more about how to integrate your favorite apps and
                tools with TravelFeed, or use the buttons on the right to learn
                more about our Hive integation and how to create a free Hive
                account.
              </p>
            </>
          )}
        </div>
        <div className="col-md-5 my-auto">
          <div className="d-flex justify-content-center">
            <a
              href="/dashboard/create-hive-account"
              rel="noopener noreferrer nofollow"
              target="_blank"
            >
              <HiveBtn text="Create a free Hive account" />
            </a>
          </div>
        </div>
      </div>
      {!isDashboard && (
        <>
          <hr className="featurette-divider" />
          <h1 className="featurette-heading pb-4">
            Frequently Asked Questions
          </h1>
        </>
      )}
      <style jsx>{`
        /* Featurettes
------------------------- */

        .featurette-divider {
          margin: 5rem 0; /* Space out the Bootstrap <hr> more */
        }

        /* Thin out the marketing headings */
        .featurette-heading,
        .featuretteh1-heading {
          font-weight: 500;
          line-height: 1;
          letter-spacing: -0.05rem;
        }
        .lead {
          font-weight: 400;
          color: #5a5a5a;
        }

        /* RESPONSIVE CSS
-------------------------------------------------- */

        @media (min-width: 40em) {
          .featurette-heading {
            font-size: 50px;
          }
          .featuretteh1-heading {
            font-size: 5rem;
          }
        }

        @media (min-width: 62em) {
          .featurette-heading {
            margin-top: 3rem;
          }
        }
      `}</style>
    </>
  );
}
